import { customModelLabel } from './customProviders'

export const DO_MEK_LABEL = 'DO Mek'

/** What the picker button reads for a preview choice; null for a real model. */
export function mockModelButtonLabel(choice, custom) {
  if (choice === 'do-mek') return DO_MEK_LABEL
  if (choice === 'custom' && custom) return customModelLabel(custom.provider, custom.model)
  return null
}
